/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-22 18:23:30
 * @modify date 2022-12-22 18:23:30
 * @desc [description]
 */

import Typography from '@mui/material/Typography';

const Footer = () => {
    return (
        <footer data-testid="footer" className="Footer--container">
            <Typography variant="overline" style={{ padding: '16px' }}>
                Copyright Paige Hart {new Date().getFullYear()}
            </Typography>
        </footer>
    )
}

export default Footer;